import { Row, Col } from 'react-bootstrap';
import React, { useState } from 'react';
import { Form, Button, Table } from 'react-bootstrap';

export default function NovaSolicitacao() {
    let [solicitacao, setSolicitacao] = useState(null);
    let [consultas, setConsultas] = useState([]);
    let [protocolo, setProcolo] = useState("");
    let [buscaRealizada, setBuscaRealizada] = useState(false);

    const formatDateAsDMY = (dataObject) => {
        const date = (new Date(dataObject.date)) ;
        const day = date.getDate();
        const month = date.getMonth() + 1; // Adding 1 to get the correct month
        const year = date.getFullYear();
        
        // Padding day and month with leading zeros if necessary
        const formattedDay = day < 10 ? `0${day}` : `${day}`;
        const formattedMonth = month < 10 ? `0${month}` : `${month}`;
      
        // Creating the formatted date string
        const formattedDate = `${formattedDay}/${formattedMonth}/${year}`;
      
        return formattedDate;
    }

    const decodeText = (text) => {
        return decodeURIComponent(escape(text));
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        fetch(`https://www.alepe.pe.gov.br/servicos/transparencia/acompanhar-sic.php?hash_sic=${protocolo}`).then(solicitacao => solicitacao.json().then((jsonResult) => {
            setSolicitacao(jsonResult.resultado);
            setConsultas(jsonResult.consultas);
            setBuscaRealizada(true);
        }));
    }

    const handleInputChange = (e) => {
        setProcolo(e.target.value);
    }

    return <Row>
        <Col xs="12">
            <p><small>Você está em <a href="/ouvidoria">SISTEMA DE INFORMAÇÃO AO CIDADÃO E OUVIDORIA</a> / Acompanhamento</small></p>
        </Col>
        <Col sm={12}>
            <h1>Acompanhamento de Solicitação</h1>
            <Form onSubmit={handleSubmit}>
                <Form.Group controlId="protocolo">
                    <Form.Label>Informe o número do protocolo</Form.Label>
                    <Form.Control
                        type="text"
                        name="protocolo"
                        onChange={handleInputChange}
                        required
                        value={protocolo}
                    />
                    <Row>
                        <Col xs={12} className="text-end mt-4">
                            <Button className="button" type="submit">
                                Buscar
                            </Button>
                        </Col>
                    </Row>
                </Form.Group>
            </Form>
        </Col>
        {solicitacao ? <Col sm={12}>
            <h3>Resultado</h3>
            <Form>
                <div>
                    {solicitacao['solicitante'] !== 'ANONIMO' && (
                        <div id="dadosUsuario">
                            <Form.Group>
                                <Form.Label>Nome</Form.Label>
                                <Form.Control type="text" value={solicitacao['solicitante']} readOnly />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>{solicitacao['tipo_identificacao'] + ':'}</Form.Label>
                                <Form.Control type="text" value={solicitacao['numero_identificacao']} readOnly />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Endereço</Form.Label>
                                <Form.Control type="text" value={solicitacao['logradouro']} readOnly />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Bairro</Form.Label>
                                <Form.Control type="text" value={solicitacao['bairro']} readOnly />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Telefone</Form.Label>
                                <Form.Control type="text" value={solicitacao['telefone']} readOnly />
                            </Form.Group>
                        </div>
                    )}

                    <Form.Group>
                        <Form.Label>Solicitação:</Form.Label>
                        <Form.Control as="textarea" className="inputMsg" value={decodeText(solicitacao['detalhamento_solicitacao'])} readOnly />
                    </Form.Group>

                    <div className="proposicao-list">
                        {consultas !== null ? (
                            <div>
                                <div className="proposicao-list-item titulo-search" style={{ marginTop: '30px' }}>
                                    <h3 className="title">Status</h3>
                                </div>
                                <Table className="table">
                                    <thead>
                                        <tr>
                                            <th>Data</th>
                                            <th>Setor</th>
                                            <th>Situação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{formatDateAsDMY(consultas['dataconsulta'])}</td>
                                            <td>{consultas['setorconsultado']}</td>
                                            <td>{consultas['situacao']}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        ) : (
                            <div>
                                <div className="proposicao-list-item titulo-search" style={{ marginTop: '30px' }}>
                                    <h3 className="title">Status</h3>
                                </div>
                                <Form.Control type="aviso" value="Ainda não há resposta oficial/definitiva para esta consulta." readOnly />
                            </div>
                        )}
                    </div>
                </div>
            </Form>
        </Col> : null}
        {(buscaRealizada && !solicitacao ? <Col sm={12}>
            <h3>Solicitação não encontrada.</h3>
        </Col> : null)}
        <Col sm={12} className="mt-5">
            <h5>SIC - SERVIÇO DE INFORMAÇÃO AO CIDADÃO</h5>

            <p>Deseja fazer o pedido de acesso à informação presencialmente?</p>
            <p>É só dirigir-se ao endereço físico do SIC da Assembleia Legislativa de Pernambuco:</p>

            <p>Endereço: Rua da União, 397, Boa Vista, Recife-PE, Anexo I, 6º Andar, Sala 603.
                <br />CEP: 50050-909
                <br />Fone: (81) 3183-2211
                <br />Ramal: 2003</p>

            <p>Horário de funcionamento: De segunda a quinta das 8h às 12h e das 14h às 18h e nas sextas das 8h às 13h</p>
        </Col>
    </Row>
}